
import { Swiper, Navigation } from "swiper";
import { mapActions } from 'vuex';
import TagCapsule from './TagCapsule.vue';

export default {
    name: "tag-container",
    components: { TagCapsule },
    props: ["search_text", "title", "pa_page_name"],
    data() {
        return {
            swiper: '',
            pa_label_list: {
                '首頁': '最近好多人搜尋',
                '旅遊/國外': '熱搜好處去',
                '旅遊/國內': '熱搜好處去',
                '美食': '超熱搜話題',
                '影視': '超熱搜話題',
                '親子': '超熱搜話題',
                '美妝': '超熱搜話題',
                '3C': '超熱搜話題',
                '身心靈': '超熱搜話題',
                '寵物': '超熱搜話題',
                '健康': '超熱搜話題',
                '職涯': '超熱搜話題',
                '住家': '超熱搜話題'
            },
        }
    },
    computed: {
        tag_data() {
            return this.$store.state.tag.tag_data;
        },
        model_id() {
            return this.$store.state.tag.all_site_model_id;
        }
    },
    methods: {
        ...mapActions('tag', [
            'getTagData',
            'getAllSiteTagData'
        ]),
        paFunction(first_index, last_index) {
            let pa_label = this.pa_label_list[this.pa_page_name]

            for(let i = first_index; i <= last_index; i ++) { 
                let pa_idx = 1 + (i + 1)/10000; 
                if (i < this.tag_data.length) {
                    window._piq.push(['trackEvent', `rs2022::十大頻道::${this.pa_page_name}`, `imps::${pa_label}::hashtag_card::${this.model_id}`, `${pa_label}::${this.tag_data[i].title}`, pa_idx]);
                }
            }
        },
    },
    async fetch() {
        const params = { group: this.search_text };
        await this.$store.dispatch("tag/getTagData", params);
        await this.getAllSiteTagData();
    },
    watch: {
        search_text: async function() {
            const params = { group: this.search_text };
            await this.$store.dispatch("tag/getTagData", params);
            await this.paFunction(0, 7);
        }
    },
    mounted() {   
        Swiper.use([Navigation]);
        this.swiper = new Swiper(".tag-swiper", {
            direction: "horizontal",
            breakpoints: {
                769: {
                    slidesPerGroup: 5,
                }
            },
            slidesPerView: 'auto',
            modules: [Navigation],
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            }
        });
        this.swiper.on('slideChange', () => {
            this.paFunction(this.swiper.realIndex + 3, this.swiper.realIndex + 7);
        });
        this.paFunction(0, 7);
    }
}
